import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import EnrollmentPage from "@/pages/EnrollmentPage";
import ThankYouPage from "@/pages/ThankYouPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "@/pages/TermsAndConditionsPage";
import CancellationBillingPolicyPage from "@/pages/CancellationBillingPolicyPage";
import EarningsDisclaimerPage from "@/pages/EarningsDisclaimerPage";

export default function App() {
  return (
    <div className="App min-h-screen bg-white text-[#1a1a24]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/enroll" element={<EnrollmentPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditionsPage />}
          />
          <Route
            path="/cancellation-billing-policy"
            element={<CancellationBillingPolicyPage />}
          />
          <Route
            path="/earnings-disclaimer"
            element={<EarningsDisclaimerPage />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
